import { css } from "@emotion/css";

const useStyles = () => {
  const columnHeader = css`
    font-weight: 600;
  `;

  return { columnHeader };
};

export default useStyles;
